import React from "react";
import { Box, Typography } from "@mui/material";

import DashboardOutlinedIcon      from "@mui/icons-material/DashboardOutlined";
import BusinessOutlinedIcon       from "@mui/icons-material/BusinessOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import GroupsOutlinedIcon         from "@mui/icons-material/GroupsOutlined";
import PersonSearchOutlinedIcon   from "@mui/icons-material/PersonSearchOutlined";
import CloudUploadOutlinedIcon    from "@mui/icons-material/CloudUploadOutlined";
import StarOutlineRoundedIcon     from "@mui/icons-material/StarOutlineRounded";
import StyleOutlinedIcon          from "@mui/icons-material/StyleOutlined";

import DrawerListItem from "../Components/DrawerListItem";
import { useSidebarAccent } from "../SidebarAccentContext";

const NavSection = ({ label, children, minimized }) => (
  <Box sx={{ mb: 0.5 }}>
    {!minimized && (
      <Typography
        sx={{
          px: 2.25,
          py: 0.75,
          fontSize: "0.6875rem",
          fontWeight: 700,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "text.disabled",
        }}
      >
        {label}
      </Typography>
    )}
    {children}
  </Box>
);

const AdminDrawer = () => {
  const { minimized } = useSidebarAccent();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", py: 1 }}>
      <Box sx={{ flex: 1, overflowY: "auto", pb: 2 }}>

        {/* Landing / at-a-glance */}
        <NavSection label="Overview" minimized={minimized}>
          <DrawerListItem name="Dashboard" path="admin" Icon={DashboardOutlinedIcon} exact />
        </NavSection>

        {/* The three profile directories */}
        <NavSection label="Profiles" minimized={minimized}>
          <DrawerListItem name="Organisations" path="admin/orgs"    Icon={BusinessOutlinedIcon} />
          <DrawerListItem name="Schools"       path="admin/schools" Icon={AccountBalanceOutlinedIcon} />
          <DrawerListItem name="Students"      path="admin/users"   Icon={GroupsOutlinedIcon} />
        </NavSection>

        {/* Things the admin needs to review / action */}
        <NavSection label="Approvals" minimized={minimized}>
          <DrawerListItem name="Students Without a School" path="students"           Icon={PersonSearchOutlinedIcon} />
          <DrawerListItem name="Manual Hour Uploads"       path="adminManualUploads" Icon={CloudUploadOutlinedIcon} />
        </NavSection>

        {/* Platform-wide settings & feedback */}
        <NavSection label="Platform" minimized={minimized}>
          <DrawerListItem name="Student Reviews" path="admin/reviews"   Icon={StarOutlineRoundedIcon} />
          <DrawerListItem name="Tags"            path="admin/AdminTags" Icon={StyleOutlinedIcon} />
        </NavSection>

      </Box>
    </Box>
  );
};

export default AdminDrawer;
